module.exports = __webpack_public_path__ + "assets/img/1441587607507_.pic_hd.98cbc3c7.jpg";